<script lang="ts">
  import Bgyoutube from "@/views/main/subviews/bgyoutube.svelte";

  import Spacer from "@/components/spacer.svelte";
  import { Col, Container, Row } from "sveltestrap";
  import { onMount } from "svelte";

  /* 
  const entity = [
    ["농업컨설팅", "Agricultural Consulting"],
    ["환경제어시스템", "Environmental Control System"],
    ["빅데이터 고도화", "Advancement of Big Data"],
    ["농업유통", "Distribution of Agricultural Products"],
    ["정부지원사업", "Government-funded projects"],
  ];
*/
  const entity = [
    ["온실시공 및 건설공사", "Greenhouse Construction"],
    ["환경제어시스템", "Environment<br/>Control System"],
    ["양액시스템", "Nutrient Solution System"],
    ["병해충예찰 시스템", "Camera System with edge computing"],
    ["농업컨설팅", "Agricultural Consulting"],
    ["스마트팜 교육", "Smartfarm Education"],
  ];

  let vmSectionHeight = 0;

  const ev메인스크롤 = (event) => {
    event.preventDefault();
    var targetElement = document.getElementById("bgyoutube").offsetHeight;
    window.scrollTo(0, targetElement - 115);
  };

  function refreshGeometry() {
    vmSectionHeight = document
      .getElementById("bgyoutube")
      .getBoundingClientRect().height;
  }

  onMount(() => {
    window.onload = refreshGeometry;
    window.onresize = refreshGeometry;
  });
</script>

<div id="bgyoutube">
  <Bgyoutube>
    <div class="section-wrap">
      <div
        class="position-absolute w-100 start-50 top-50 translate-middle text-center"
      >
        <h1 class="bandi-title">
          Bandiburri is<br />
          <b>Standard of Smart Farm System</b>
        </h1>
        <h2 class="p-2">반딧불이는 농업 빅데이터기반의 국내 No.1 스마트팜 전문기업입니다.</h2>
        <Spacer size="4rem" class_ext="mobile-0rem" />
        <Container>
          <Row>
            <Col xs={{ offset: 1, size: 10 }}>
              <Row>
                {#each entity as e, i}
                  <div class="col-12 col-md p-2 entity">
                    <div class="row">
                      <div class="col-4 col-md-12">
                        <img src="/images/main/s1_{i + 1}.png" alt={e[0]} />
                      </div>
                      <div class="col-8 col-md-12">
                        <div>
                          <h2 class="my-0 my-md-3">{@html e[0]}</h2>
                          <h3 class="mb-0 mb-md-1 text-wrap">{@html e[1]}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                {/each}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
    <div class="contactbtn">
      <a href="/contact">문의하기</a>
    </div>
    <div class="main_down">
      <button
        type="button"
        class="main_down"
        id="img_btn"
        on:click={ev메인스크롤}
      >
        <img src="/images/main/more-down.png" alt="아래로스크롤이미지" />
      </button>
    </div>
  </Bgyoutube>
</div>

<style lang="scss">
  h1 {
    font-size: 3rem;
  }

  h2 {
    font-size: 1rem;
    color: #cfcfcfd9;
  }

  h3 {
    font-size: 1rem;
    color: #cfcfcfd9;
  }

  // media-breakpoint-up 을 사용하기 위함
  @import "../../../global.scss";
  @include media-breakpoint-up(sm) {
    h1 {
      font-size: 4rem;
    }
  }

  .section-wrap {
    width: 100%;
    height: 100%;
    color: white;

    * {
      z-index: 10;
    }

    img {
      width: 40%;
    }
  }
  .contactbtn {
    width: 125px;
    height: 50px;
    font-size: 25px;
    text-align: center;
    line-height: 50px;
    font-weight: bold;
    position: absolute;
    bottom: 10%;
    left: calc(50% - 62.5px);
    z-index: 98;
  }
  .contactbtn a {
    font-size: 19px;
    width: 100%;
    height: 100%;
    text-align: center;
    color: #fff;
    border: 1px solid #fff;
    border-radius: 9px;
    transition: all 0.3s;
    display: block;
    text-decoration: none;
  }
  .contactbtn a:hover {
    background-color: rgb(255 255 255 / 38%);
  }
  .main_down {
    display: block;
    left: calc(50% - 25px);

    display: block;
    position: absolute;
    bottom: 15px;
    width: 50px;
    z-index: 98;
  }
  .main_down img {
    width: 30px;
    filter: invert(100);
  }
  .main_down button {
    border: none;
    background: none;
  }
  @media (max-width: 767.99px) {
    .bandi-title {
      font-size: 2rem !important;
    }
    .contactbtn {
      bottom: 6% !important;
    }
    .main_down {
      bottom: 5px !important;
    }
  }

</style>
